<template>
  <form @submit.stop.prevent="validate">
    <InputBig
      v-model="form.email"
      :placeholder="$bimTranslate('form.email', activeLang)"
      type=email
      dadataType=email
      class="mb-9"
      :formModel="_self"
      formKey="form.email"
    />

    <InputBig
      v-model="form.name"
      :placeholder="$bimTranslate('form.name', activeLang)"
      @keypress.enter.native.stop.prevent="validate"
      class="mb-6"
    />

    <div class="info-block my-11">
      <bim-text type=medium>{{ $bimTranslate('form.encrypt', activeLang) }}</bim-text>
    </div>

    <TextValid v-if="$v2.errors['form.email']">{{ $bimTranslate('form.enterEmail', activeLang) }}</TextValid>
    <TextValid v-if="$v2.validForm">{{ $bimTranslate('form.readyToSend', activeLang) }}</TextValid>

    <ButtonBig
      :disabled="!$v2.validForm"
      :label="$bimTranslate('form.sendRequest', activeLang)"
      class="mt-6"
      type="submit"
    />
  </form>
</template>

<script>
import ButtonBig from './ButtonBig.vue'
import InputBig from './InputBig.vue'
import TextValid from './TextValid.vue'

import stepMixin from './step.mixin'

export default {
  mixins: [stepMixin],
  inject: ['activeLang'],
  components: {
    ButtonBig,
    InputBig,
    TextValid
  },
  computed: {
    formValidation () {
      return {
        'form.email': ['required', 'email']
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.info-block {
  width: 15.8rem;
  text-align: center;
  margin: auto;
}
</style>
